"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OidcAccessToken_1 = require("./OidcAccessToken");
var SessionValue_1 = require("./SessionValue");
var OidcIdToken_1 = require("./OidcIdToken");
var OidcSessionStorage = /** @class */ (function () {
    function OidcSessionStorage() {
        var _this = this;
        this.TOKEN_PARAM = 'AuthToken';
        this.IDTOKEN_PARAM = 'AuthIdToken';
        this.STATE_PARAM = 'AuthState';
        this.NONCE_PARAM = 'AuthNonce';
        this.State = new SessionValue_1.SessionValue(this.STATE_PARAM);
        this.Nonce = new SessionValue_1.SessionValue(this.NONCE_PARAM);
        this.Token = new SessionValue_1.SessionValue(this.TOKEN_PARAM);
        this.IdToken = new SessionValue_1.SessionValue(this.IDTOKEN_PARAM);
        this.getAccessToken = function () {
            var token = _this.Token.get();
            if (token) {
                return new OidcAccessToken_1.OidcAccessToken(token);
            }
            return null;
        };
        this.storeAccessToken = function (oidcToken) {
            _this.Token.set(oidcToken.toString());
        };
        this.getIdToken = function () {
            var token = _this.IdToken.get();
            if (token) {
                return new OidcIdToken_1.OidcIdToken(token);
            }
            return null;
        };
        this.storeIdToken = function (oidcIdToken) {
            _this.IdToken.set(oidcIdToken.toString());
        };
    }
    return OidcSessionStorage;
}());
exports.OidcSessionStorage = OidcSessionStorage;
//# sourceMappingURL=OidcSessionStorage.js.map